var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "16",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#252525",
          d:
            "M22 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
        }
      }),
      _c("path", {
        attrs: { fill: "#EB001B", d: "M9 13A5 5 0 1 0 9 3a5 5 0 0 0 0 10Z" }
      }),
      _c("path", {
        attrs: { fill: "#F79E1B", d: "M15 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" }
      }),
      _c("path", {
        attrs: {
          fill: "#FF5F00",
          "fill-rule": "evenodd",
          d:
            "M12 4c1.214.912 2 2.364 2 4a4.993 4.993 0 0 1-2 4 4.993 4.993 0 0 1-2-4c0-1.636.786-3.088 2-4Z",
          "clip-rule": "evenodd"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }